export interface Registration {
  username: string;
  password: string;
}

export interface ActionType {
  FETCH_REG_REQUEST: any;
  FETCH_REG_SUCCESS: string;
  FETCH_REG_ERROR: string;

  FETCH_REG_INIT: string;
  FETCH_REG_CONFIRMATION_REQUEST: string;
  FETCH_REG_CONFIRMATION_SUCCESS: string;
  FETCH_REG_CONFIRMATION_ERROR: string;
}

export const RegActionTypes: ActionType = {
  FETCH_REG_REQUEST: '@@FETCH_REG_REQUEST',
  FETCH_REG_SUCCESS: '@@FETCH_REG_SUCCESS',
  FETCH_REG_ERROR: '@@FETCH_REG_ERROR',

  FETCH_REG_INIT: '@@FETCH_REG_INIT',
  FETCH_REG_CONFIRMATION_REQUEST: '@@FETCH_REG_CONFIRMATION_REQUEST',
  FETCH_REG_CONFIRMATION_SUCCESS: '@@FETCH_REG_CONFIRMATION_SUCCESS',
  FETCH_REG_CONFIRMATION_ERROR: '@@FETCH_REG_CONFIRMATION_ERROR'
};

export interface RegState {
  submitting: boolean;
  isRegistered?: boolean;
  errors?: string;
  data?: Object;
  userName?: string;
  init?: boolean;
}
